export default __webpack_public_path__ + "static/media/plane.413d25a9.jpg";